import DocumentTitle from './DocumentTitle'
import documentTitleContainer from './documentTitleContainer'

export default documentTitleContainer(DocumentTitle)
